import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-regime-list",
	imports: [FormsModule, NgTemplateOutlet],
	templateUrl: "./regime-list.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class RegimeListComponent {
	@Input()
	public regimes: APIResults.RegimeCount[];
	// Header label for the evaluate checkbox column ("Eval" is used where space is tight)
	@Input()
	public evaluateHeader = "Evaluate";
	// Number of extra columns projected via regimeHeaderCells/regimeRowCells, used to size loading/empty rows
	@Input()
	public extraColumns = 0;
	@Output()
	public evaluateChange = new EventEmitter<void>();

	// Optional extra <th> cells appended to the header row
	@ContentChild("regimeHeaderCells")
	public headerCells?: TemplateRef<unknown>;
	// Optional extra <td> cells appended to each regime row; receives the regime as $implicit
	@ContentChild("regimeRowCells")
	public rowCells?: TemplateRef<{ $implicit: APIResults.RegimeCount }>;
}
